import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

const WIDTHS = {
  small: '368px',
  medium: '560px',
  large: '848px',
  'extra-large': '960px',
};

export default class Modal extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    isOpen: PropTypes.bool,
    modalStyle: PropTypes.object,
    onRequestClose: PropTypes.func,
    size: PropTypes.oneOf(Object.keys(WIDTHS)),
    style: PropTypes.object,
  };

  static defaultProps = {
    children: null,
    isOpen: false,
    modalStyle: {},
    onRequestClose: () => {},
    size: 'medium',
    style: {},
  };

  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    if (this._modal) {
      this._modal.addEventListener('scroll', this.handleScroll);
      this._modal.addEventListener('wheel', this.handleScroll);
    }
  }

  componentWillUnmount() {
    if (this._modal) {
      this._modal.removeEventListener('scroll', this.handleScroll);
      this._modal.addEventListener('wheel', this.handleScroll);
    }
  }

  getClassName(isOpen, className) {
    return [isOpen ? 'Modal' : 'Modal-hidden', className].join(' ');
  }

  getModalStyle(modalStyle, width) {
    return {
      ...modalStyle,
      width,
    };
  }

  getWidth(size) {
    return WIDTHS[size];
  }

  render() {
    const className = this.getClassName(
      this.props.isOpen,
      this.props.className,
    );
    const width = this.getWidth(this.props.size);
    const modalStyle = this.getModalStyle(this.props.modalStyle, width);
    return (
      <div
        className={`Modal ${className}`}
        ref={(modal) => (this._modal = modal)}
        style={this.props.style}>
        <div className='Modal-inner' style={modalStyle}>
          {React.Children.map(this.props.children, (child) =>
            React.cloneElement(child, {
              isOpen: this.props.isOpen,
            }),
          )}
        </div>
      </div>
    );
  }

  handleScroll(event) {
    event.stopPropagation();
  }
}
